import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// 15s timeout — fail fast on slow mobile connections instead of hanging forever
export const api = axios.create({ baseURL: API_BASE, timeout: 15000 });

let _token = localStorage.getItem("aegis_token");
if (_token) api.defaults.headers.common.Authorization = `Bearer ${_token}`;

export function setAuthToken(token) {
    _token = token;
    if (token) {
        localStorage.setItem("aegis_token", token);
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
        localStorage.removeItem("aegis_token");
        delete api.defaults.headers.common.Authorization;
    }
}

export function getAuthToken() {
    return _token;
}

// ---------------- format helpers ----------------
export function fmtAone(n, decimals = 2) {
    if (n === null || n === undefined || Number.isNaN(Number(n))) return "-";
    const num = Number(n);
    if (num >= 1e9) return (num / 1e9).toFixed(2) + "B";
    if (num >= 1e6) return (num / 1e6).toFixed(2) + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(2) + "K";
    return num.toLocaleString(undefined, { maximumFractionDigits: decimals });
}
export function fmtNum(n) {
    return Number(n || 0).toLocaleString();
}
export function shortHash(h, head = 8, tail = 6) {
    if (!h) return "-";
    if (h.length <= head + tail + 2) return h;
    return `${h.slice(0, head)}…${h.slice(-tail)}`;
}
export function shortAddr(a, head = 8, tail = 6) {
    return shortHash(a, head, tail);
}
export function timeAgo(iso) {
    if (!iso) return "-";
    const t = new Date(iso).getTime();
    const s = Math.max(0, Math.floor((Date.now() - t) / 1000));
    if (s < 60) return `${s}s ago`;
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return `${Math.floor(s / 86400)}d ago`;
}

/**
 * Normalize any API error into a plain string. FastAPI + Pydantic v2 return
 * `detail` as an ARRAY of validation error objects for 422 responses. If we
 * pass that array straight into React/Sonner it crashes with
 * "Objects are not valid as a React child".
 *
 * Also translates the ambiguous axios "Network Error" and "timeout of Xms exceeded"
 * messages into a mobile-friendly, actionable string so we can debug user reports.
 */
export function formatApiError(err, fallback = "Something went wrong") {
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) {
        return detail
            .map((d) => (typeof d === "string" ? d : d?.msg || JSON.stringify(d)))
            .join(" · ");
    }
    if (detail && typeof detail === "object") {
        return detail.msg || detail.message || JSON.stringify(detail);
    }
    if (typeof err === "string") return err;

    // Axios-specific error translations for mobile debugging
    const code = err?.code;
    const msg = err?.message || "";
    if (code === "ECONNABORTED" || /timeout/i.test(msg)) {
        return "Server took too long to respond. Please check your internet and try again.";
    }
    if (msg === "Network Error" || code === "ERR_NETWORK") {
        // Give the user something actionable rather than a generic "Network error"
        return "Can't reach the server. Check your internet connection or try disabling any VPN / ad-blocker / battery-saver, then retry.";
    }
    return msg || fallback;
}
